import { render, staticRenderFns } from "./SendToEhr.vue?vue&type=template&id=278f2741&scoped=true&"
import script from "./SendToEhr.vue?vue&type=script&lang=js&"
export * from "./SendToEhr.vue?vue&type=script&lang=js&"
import style0 from "./SendToEhr.vue?vue&type=style&index=0&id=278f2741&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278f2741",
  null
  
)

export default component.exports